/**
 * @author Ariel
 * @description 考试记录管理列表
 * @Date 2020/02/03
 */
import React from "react";
import moment from "moment";
import { WizClassifySelect } from '../../common'

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const formatterFaceAuthStatus = (val) => {
  //人脸是否有待审核和 {0 否,1 是,2 无状态}
  let newVal;
  switch (val) {
    case 0:
      newVal = '否'
      break;
    case 1:
      newVal = '是'
      break;
    case 2:
      newVal = ''
      break;
    default:
      newVal = '';
  }
  return newVal;
}

let componentName = 'examRecord'
const columns = [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '考试名称',
    name: 'title',
    searchItem: {},
  },
  {
    title: "考试分类",
    name: "categoryTypeIds",
    searchItem: {
      type: 'diy',
      diy: WizClassifySelect,
      returnKey: true,
      wizTreeSelectListProps: {
        itemProps: {
          icon: 'unordered-list',
          title: '考试分类',
          tips: '请选择考试分类'
        },
        treeProps: { checkStrictly: true },
        checkable: false
      },
      apiProps: { type: 0 },
      selectProps: {
        placeholder: '请选择考试分类',
      },
    }
  },
  {
    title: '考试状态',
    name: 'status',
    dict: [
      { code: 0, codeName: '草稿' },
      { code: 1, codeName: '已发布' },
      { code: 2, codeName: '已关闭' }
    ],
    searchItem: { type: 'select' }
  },
  // {
  //   title: '关联内容',
  //   name: 'relationContent',
  //   searchItem: {
  //   }
  // },
  // {
  //   title: '身份验证',
  //   name: 'face',
  //   dict: [
  //     {code: 1, codeName: '是'},
  //     {code: 0, codeName: '否'}
  //   ],
  //   searchItem: {
  //     type: 'select'
  //   }
  // },
  {
    title: '考试名称',
    name: 'title',
    tableItem: {
      width: 200
    }
  },
  {
    title: '考试分类',
    name: 'categoryName',
    tableItem: {}
  },
  {
    title: '考试类型',
    name: 'examType',
    tableItem: {
      render: (text, record) => {
        if(text==='0') {
          return '独立考试'
        } else if (text==='1'){
          return '课程考试'
        } else {
          return '独立考试、课程考试'
        }
      }
    }
  },
  // {
  //   title: '关联内容',
  //   name: 'relationContent',
  //   tableItem: {
  //   }
  // },
  {
    title: '开始时间',
    name: 'startDate',
    tableItem: {
      render: (text) => {
        return formatterDate(text)
      }
    }
  },
  {
    title: '结束时间',
    name: 'endDate',
    tableItem: {
      render: (text) => {
        return formatterDate(text)
      }
    }
  },
  {
    title: '状态',
    name: 'status',
    tableItem: {},
    dict: [
      { code: 0, codeName: '草稿' },
      { code: 1, codeName: '已发布' },
      { code: 2, codeName: '已关闭' }
    ],
  },
  // {
  //   title: '身份验证',
  //   name: 'face',
  //   dict: [
  //     {code: 1, codeName: '是'},
  //     {code: 0, codeName: '否'}
  //   ],
  //   tableItem: {}
  // },
  {
    title: '已交卷',
    name: 'completeNum',
    tableItem: {}
  },
  {
    title: '已通过',
    name: 'passNum',
    tableItem: {}
  },
  // {
  //   title: '是否有待审核',
  //   name: 'faceAuthStatus',
  //   dict: [
  //     {code: 1, codeName: '是'},
  //     {code: 0, codeName: '否'}
  //   ],
  //   searchItem: {
  //     type: 'select'
  //   }
  // },
  // {
  //   title: '是否有待审核',
  //   name: 'faceAuthStatus',
  //   tableItem: {
  //     render: (text) => {
  //       return formatterFaceAuthStatus(text)
  //     }
  //   }
  // },
  // {
  //   title: '身份待审核人数',
  //   name: 'faceAuthCount',
  //   tableItem: {
  //     render: (text, record) => {
  //       let {face} = record;
  //       if (face!=null && face===1){
  //         return text && text;
  //       }
  //       return '';
  //     }
  //   }
  // },
];

const templateConfig = (data) => {
  let {pathname} = data
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns,
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'primary' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filter) => {
                  return { ...filter };
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
          maxNum: 2
        },
        rowOperateSort: ['resultsView', 'examRecordView', 'examPreview', 'examPersonAuth', 'review',
          'exportByChoosePosition', 'exportByEmploymentInfo',
          'exportStudentsAnswers', 'exportQuestionBank', 'errorQuestionInfo'],
        rowOperateView: [
          {
            key: 'examPersonAuth',//考试人脸记录
            custom: true,
            params: { children: '身份验证记录' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: pathname+'/examPersonAuth'
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = true;
              let hidden = true;
              if (record && (record.face != null && record.face != undefined && record.face === 1)) {
                disabled = false;
                hidden = false;
              }
              return { disabled: disabled, hidden }
            }
          },
          {
            key: 'review',
            custom: true,
            params: { children: '身份验证审核' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: pathname+'/examRecordAuthAudit'
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = true;
              let hidden = true;
              let { face, faceAuthStatus, faceAuthCount } = record;
              if (record && (face != null && face != undefined && face === 1) &&
                (faceAuthStatus != null && faceAuthStatus != undefined && faceAuthStatus === 1) &&
                (faceAuthCount != null && faceAuthCount != undefined && faceAuthCount > 0)
              ) {
                disabled = false;
                hidden = false;
              }
              return { disabled: disabled, hidden }
            }
          },
          {
            key: 'resultsView',//成绩查看
            custom: true,
            params: { children: '成绩查看' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: pathname+'/examGradeInfo'
              }
            }
          },
          {
            key: 'examRecordView',//考试记录查看
            custom: true,
            params: { children: '考试记录查看' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: pathname+'/examRecordInfo'
              }
            }
          },
          {
            key: 'examPreview',
            custom: true,
            params: { children: '考试预览' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: pathname+'/examInfo'
              }
            }
          },
          {
            key: 'exportByChoosePosition',
            custom: true,
            params: { children: "按选择任职导出成绩" },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'exportByPosition',
                apiParams: {}
              },
              formatParams: (rows, record, filters) => {
                let examId = record['id'];
                return { examId }
              }
            }
          },
          {
            key: 'exportByEmploymentInfo',
            custom: true,
            params: { children: "按任职情况导出成绩" },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'exportByPositionInfo',
                apiParams: {}
              },
              formatParams: (rows, record, filters) => {
                let examId = record['id'];
                return { examId }
              }
            }
          },
          {
            key: 'exportStudentsAnswers',
            custom: true,
            params: { children: "导出学员答题情况" },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'exportByStudentAnswerDetail',
                apiParams: {}
              },
              formatParams: (rows, record, filters) => {
                let examId = record['id'];
                let examTitle = record['title'];
                return { examId, examTitle }
              }
            }
          },
          {
            key: 'exportQuestionBank',
            custom: true,
            params: { children: "导出题库出题情况" },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'exportByQuestionAnswerDetail',
                apiParams: {}
              },
              formatParams: (rows, record, filters) => {
                let examId = record['id'];
                return { examId }
              }
            }
          },
          {
            key: 'errorQuestionInfo',//错题率详情
            custom: true,
            params: { children: '错题率详情' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: pathname+'/errorQuestionInfo'
              }
            }
          },
        ]
      }
    }
  }
};

const apis = (self) => {
  return {
    list: {
      path: `${componentName}/list${'/perm/examRecordPerm' !== self?.pathname ? '': 'Look'}`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export${'/perm/examRecordPerm' !== self?.pathname ? '': 'Look'}`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    },
    exportByPosition: {
      path: `${componentName}/gradeExportByPosition${'/perm/examRecordPerm' !== self?.pathname ? '': 'Look'}`,
      payload: {
        key: `${componentName}@gradeExportByPosition`,
        apiParams: {}
      }
    },
    exportByPositionInfo: {
      path: `${componentName}/gradeExportByPositionInfo${'/perm/examRecordPerm' !== self?.pathname ? '': 'Look'}`,
      payload: {
        key: `${componentName}@gradeExportByPositionInfo`,
        apiParams: {}
      }
    },
    exportByStudentAnswerDetail: {
      path: `${componentName}/exportByStudentAnswerDetail${'/perm/examRecordPerm' !== self?.pathname ? '': 'Look'}`,
      payload: {
        key: `${componentName}@exportByStudentAnswerDetail${'/perm/examRecordPerm' !== self?.pathname ? '': 'Look'}`,
        apiParams: {}
      }
    },
    exportByQuestionAnswerDetail: {
      path: `${componentName}/exportByQuestionAnswerDetail${'/perm/examRecordPerm' !== self?.pathname ? '': 'Look'}`,
      payload: {
        key: `${componentName}@exportByQuestionAnswerDetail${'/perm/examRecordPerm' !== self?.pathname ? '': 'Look'}`,
        apiParams: {}
      }
    }
  }
}

let reduxTemplateConfig = (self, args) => {
  return {
    apis: apis(self),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
